import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../common/containers/icon';
const ErrorDetailsToggle = ({
  hint: _hint = '',
  technicalDetail: _technicalDetail = '',
  reference: _reference = '',
  errorCode: _errorCode = ''
}) => {
  const [expanded, setExpanded] = useState(false);
  const panelId = useId();
  const hasDetails = _hint.length || _technicalDetail.length || _reference.length || _errorCode.length;
  if (!hasDetails) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "t-error-details"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "t-error-details-toggle",
    "aria-label": expanded ? 'Hide error details' : 'Show error details',
    "aria-expanded": expanded,
    "aria-controls": panelId,
    onClick: () => setExpanded(open => !open)
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "info-circle",
    ariaLabel: "Error details"
  }))), expanded ? /*#__PURE__*/React.createElement("div", {
    className: "t-error-details-panel",
    id: panelId
  }, _hint.length ? /*#__PURE__*/React.createElement("div", null, _hint) : null, _technicalDetail.length ? /*#__PURE__*/React.createElement("div", {
    className: "t-error-details-technical"
  }, _technicalDetail) : null, _reference.length ? /*#__PURE__*/React.createElement("div", {
    className: "t-error-details-reference"
  }, `Reference: ${_reference}`) : null, _errorCode.length ? /*#__PURE__*/React.createElement("div", {
    className: "t-error-details-code"
  }, `Code: ${_errorCode}`) : null) : null);
};
ErrorDetailsToggle.propTypes = {
  hint: PropTypes.string,
  technicalDetail: PropTypes.string,
  reference: PropTypes.string,
  errorCode: PropTypes.string
};
export default ErrorDetailsToggle;